/// <reference path="../../app.definition.ts" />


angular.module('eCareVault.common.filters').filter('noDecimalCurrency',
  ['$filter', '$locale', function (filter, locale) {
    const currencyFilter = filter('currency');
    const formats = locale.NUMBER_FORMATS;
    return function (amount, currencySymbol) {
      amount = amount ? (Number(amount)).toFixed(2) : 0.00;
      const value = currencyFilter(amount, currencySymbol);
      // split into parts
      const parts = value.split(formats.DECIMAL_SEP);
      const dollar = parts[0];
      let cents = parts[1] || '00';
      cents = cents.substring(0, 2) == '00' ? cents.substring(2) : '.' + cents;
      return dollar + cents;
    };
  }]);
